module.exports = __webpack_public_path__ + "static/d1Res1-9459eade11e5792269add288607bcb1c.png";